import { Component } from '@angular/core';

@Component({
  selector: 'app-terms-of-use',
  imports: [],
  templateUrl: './terms-of-use.html',
  styleUrl: './terms-of-use.scss',
})
export class TermsOfUse {

}
